import React from 'react';
import { styled } from '@mui/material/styles';
import ErrorBoundary from 'sensortower-components/src/base-components/ErrorBoundary';
import { sidekick } from '../../utils/sidekick';

export interface ModuleIntegrationIFrameProps {
  id?: string;
  sidekickLookup: any;
  settings?: {
    src?: string;
    width?: number;
    height?: number;
    aspectRatio?: number;
  };
}

const ModuleIntegrationIFrame = ({ id, sidekickLookup, settings }: ModuleIntegrationIFrameProps) => {
  if (!settings || !settings.src) return null;

  // These come from the CMS, so technically they can be anything, not only numbers :/
  const width = settings.width ?? '100%';
  const height = settings.height ?? '100%';
  // Ensure that the aspect ratio is a positive number not larger than 1
  const aspectRatio = Math.min(1, Number.isFinite(settings.aspectRatio) ? Math.abs(settings.aspectRatio as number) : 1);

  return (
    <ErrorBoundary>
      <Wrapper width={width} height={height} aspectRatio={aspectRatio}>
        <Root id={id} width="100%" height="100%" {...sidekick(sidekickLookup)} src={settings?.src} allowFullScreen />
      </Wrapper>
    </ErrorBoundary>
  );
};

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => !['width', 'height', 'aspectRatio'].includes(prop as string),
})((props: { width: string | number; height: string | number; aspectRatio: number }) => ({
  position: 'relative',
  width: props.width,
  height: props.height,
  paddingBottom: `calc(${props.aspectRatio} * 100%)`,
  overflow: 'hidden',
}));

const Root = styled('iframe', {
  name: 'ModuleIntegrationIFrame',
  slot: 'EmbedRoot',
  shouldForwardProp: (prop) => !['variant', 'width', 'height'].includes(prop as string),
  overridesResolver: (_, styles) => [styles.root],
})<{ variant?: string }>(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  border: 'none',
}));

export default ModuleIntegrationIFrame;
